import React, {useState} from 'react'
import {Input} from '@thryvlabs/maverick'
import {ALLOWED_DOMAINS, FORBIDDEN_DOMAINS} from '../../utils/constants'

const ERROR_MESSAGES = ['This field is required', 'Please enter a valid domain']
// const FORBIDDEN_DOMAINS = ['google', 'bing', 'twitter', 'facebook', 'amazon']

function DomainValidation({
  domainConfig,
  setDomainConfig,
  validExtensionList,
  isOptional = false,
}) {
  const [errorMessageConfig, setErrorMessageConfig] = useState({
    showMessage: false,
    message: 'hola',
  })

  const isValidDomain = domainString => {
    if (!domainString || typeof domainString !== 'string') return false
    const domain = domainString.trim().toLowerCase()
    ERROR_MESSAGES[1] = `Please enter a valid domain`

    const hasPathOrQuery = /[/?#]/.test(domain)
    const isAllowedBusinessUrl = ALLOWED_DOMAINS.some(d => domain.includes(d))
    if (hasPathOrQuery && !isAllowedBusinessUrl) {
      ERROR_MESSAGES[0] += `No text is allowed after '.com' or similar.`
      return false
    }

    const normalized = domain
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split(/[/?#]/)[0]

    for (const d of FORBIDDEN_DOMAINS) {
      if (
        normalized === `${d}.com` ||
        normalized.includes(`.${d}.`) ||
        normalized.startsWith(`${d}.`) ||
        normalized.endsWith(`.${d}.com`)
      ) {
        ERROR_MESSAGES[1] += `. The domain ${domain} is not allowed.`
        return false
      }
    }

    for (const allowed of ALLOWED_DOMAINS) {
      if (domain.includes(allowed)) return true
    }

    const labels = normalized.split('.')
    for (const label of labels) {
      if (!label) {
        ERROR_MESSAGES[1] += `. Domain has empty URL.`
        return false
      }
      if (label.length > 63) {
        ERROR_MESSAGES[1] += `. URL "${label}" exceeds 63 characters.`
        return false
      }
      if (label.startsWith('-') || label.endsWith('-')) {
        ERROR_MESSAGES[1] += `. URLs cannot start or end with '-'.`
        return false
      }
    }

    const tld = labels[labels.length - 1]
    if (!validExtensionList.includes(tld)) {
      ERROR_MESSAGES[1] += `. "${tld}" is not a recognized domain extension.`
      return false
    }

    const domainRegex =
      /^(?!-)[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,63}$/i
    if (!domainRegex.test(normalized)) {
      ERROR_MESSAGES[1] += `. Domain format is not valid.`
      return false
    }

    const escapedExtensions = validExtensionList.map(ext =>
      ext.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
    )
    // nosemgrep: eslint.detect-non-literal-regexp
    const doubleTldRegex = new RegExp(
      `\\.(${escapedExtensions.join('|')}){2,}$`,
      'i',
    )
    if (doubleTldRegex.test(normalized)) {
      ERROR_MESSAGES[0] += `Domain cannot contain repeated TLDs like ".comcom" or similar.`
      return false
    }
    // ==== old logic ====
    // ERROR_MESSAGES[1] = `Please enter a valid domain`
    // for (const domain of FORBIDDEN_DOMAINS) {
    //   if (
    //     domainString.includes(`.${domain}.`) ||
    //     domainString.startsWith(`${domain}.`) ||
    //     domainString.endsWith('yelp.com')
    //   ) {
    //     ERROR_MESSAGES[1] += `. The domain ${domain} is not allowed.`
    //     return false
    //   }
    // }
    // const splitUrl = domainString.split('www.')
    // const plainURL = splitUrl[splitUrl.length - 1]
    // const label = plainURL.slice(0, plainURL.indexOf('.'))
    // if (
    //   label.length > 63 ||
    //   label.startsWith('-') ||
    //   domainString.startsWith('-')
    // ) {
    //   ERROR_MESSAGES[1] += `.Max domain length is 63. The domain cannot start or end with '-'`
    //   return false
    // }
    // const regex =
    //   /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}|((yelp|yellowpages)\.com(\.au)?)\/[a-zA-Z0-9\-/?=.+]+)$/
    // if (!regex.test(domainString)) {
    //   ERROR_MESSAGES[1] += `. No text is allowed after '.com' or similar.`
    // }
    // return regex.test(domainString)
    return true
  }

  const handleErrorValidation = ({value, isValid}) => {
    if (value.length === 0) {
      if (isOptional) {
        setErrorMessageConfig({showMessage: false, message: ''})
        return
      }
      setErrorMessageConfig({showMessage: true, message: ERROR_MESSAGES[0]})
      return
    }
    if (value.length >= 3) {
      if (isValid) {
        setErrorMessageConfig({showMessage: false, message: ''})
        return
      }
      setErrorMessageConfig({showMessage: true, message: ERROR_MESSAGES[1]})
      return
    }
  }

  const handleDomainValue = ({target: {value}}) => {
    const isValid =
      isOptional && value.length === 0 ? true : isValidDomain(value)
    handleErrorValidation({value, isValid})
    setDomainConfig(prevState => ({...prevState, value, isValid}))
  }

  return (
    <div className="domain-container mb-4">
      <p className="m-0 text-dark pb-3">
        {isOptional
          ? 'Enter domain (optional)'
          : 'Enter domain to continue to purchase'}
        {!isOptional && <span className="text-error"> *</span>}
      </p>
      <Input
        aria-label="Domain"
        required={!isOptional}
        type="text"
        placeholder="Enter your website domain, YP, or Yelp URL"
        name="domain"
        withLabel
        labelType="static"
        variant="input-isolated"
        onChange={handleDomainValue}
        value={domainConfig.value}
      />
      {errorMessageConfig.showMessage && (
        <p className="m-0 text-error pt-2">{errorMessageConfig.message}</p>
      )}
    </div>
  )
}

export {DomainValidation}
